import { createSignal, onMount } from "solid-js";
import { useApplication } from "@/context/app";
import {
  Card,
  CardContent,
} from "@/components/shadcn/card";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListControl } from "../../components/ui/list/ListControl";
import TherapyRow from "./row";
import { ListView } from "../../components/ui/list/ListView";
import { CreateButton } from "../../components/ui/Button";

export default function TherapyList() {

  const { setBreadcrumb } = useApplication();

  const actions = [
    activateAction('therapy', 'therapy'),
    deactivateAction('therapy', 'therapy'),
    deleteAction('therapy', 'therapy')
  ];

  const statuses = [{
    text: 'Active',
    value: true
  }, {
    text: 'Inactive',
    value: false
  }];

  const sorts = [{
    "text": 'Created At',
    "value": "created_at"
  }, {
    "text": 'Name',
    "value": "name"
  }];

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Therapies',
        current: true
      }
    ]);
  });

  return (
    <>
      <div class="flex">
        <CreateButton href="/therapy/create">New Therapy</CreateButton>
      </div>
      <Card class="w-full">
        <CardContent>
          <ListControl
            mode="list"
            search={''}
            actions={actions}
            filters={[
              {
                type: 'choice',
                label: 'Status',
                name: 'status',
                choices: statuses,
                default: null
              },
              {
                type: 'date',
                label: 'Created At',
                name: 'created_at',
                default: null
              }
            ]}
            sort={{
              column: 'created_at',
              direction: 'asc',
              options: sorts
            }}
            pagination={{
              current: 1, // default 1
              changePerPage: true, // default true
              perPage: 10, // default 10
              options: [10, 20, 50, 100]
            }}
            datasource={{
              type: 'remote',
              config: {
                url: '/therapy/fetch',
                method: 'GET',
                params: {
                  //status: status()
                }
              }
            }}
            contentLoading={false}
          >{(innerProps) => <ListView {...innerProps} template={TherapyRow} placeholder={false} />}
          </ListControl>
        </CardContent>
      </Card>
    </>
  );
}
